import React, { Component } from "react";
import api from '../../../apiClient/v1'

export class EnrocarOperadores extends Component{
    constructor (props){
        super(props)
        this.state= {

        }
    }

    render() {
        let conteo_titular = 0
        let conteo_reemplazo = 0
        let diferencia = 0
        let stock_actual = this.props.stock.replace(',', '')
        stock_actual = Math.abs(stock_actual)
        let conteo_actual = this.props.sumaUnidades.replace(',', '')
        this.props.titulares.map(suma => {
            return conteo_titular += suma.conteo
        })
        this.props.reemplazos.map(suma => {
            return conteo_reemplazo += suma.conteo
        })
        let conteo_total = (conteo_actual - conteo_titular) + conteo_reemplazo
        diferencia = conteo_total - stock_actual
        return <div>
            <p style={{textAlign: 'center', fontWeight: 'bold'}}>RESUMEN DEL ENROQUE</p>
            <div className="row">
                <div className="col-md-6" style={{textAlign: 'center'}}>Entran a titulares
                    {this.props.reemplazos.map((r, reemplazo) => {
                        return <p key={reemplazo} style={{textAlign: 'center', backgroundColor: '#33EE8B'}}>{r.nombre} - Conteo: {r.conteo}</p>
                })}
                </div>
                <div className="col-md-6" style={{textAlign: 'center'}}>Salen a reemplazo
                    {this.props.titulares.map((t, titular) => {
                            return <p key={titular} style={{textAlign: 'center', backgroundColor: '#F96A6A'}}>{t.nombre} - Conteo: {t.conteo}</p>
                            
                    })}
                </div>
                    <br/>
                    <p style={{textAlign: 'center', marginTop: '10px', fontWeight: 'bold'}}>NUEVO PORCENTAJE CONTEO SUGERIDO</p>
                    <p style={{textAlign: 'center', backgroundColor: this.props.panelConteo, color: this.props.letra}}>{this.props.mensaje}</p>
                <div>
                    <p style={{textAlign: 'center', marginTop: '10px', fontWeight: 'bold'}}>NUEVO CONTEO Y DIFERENCIA</p>
                    <p style={{textAlign: 'center'}}>Conteo: {conteo_total.toLocaleString()}</p>
                    <p style={{textAlign: 'center'}}>Diferencia: {diferencia.toLocaleString('de-DE')}</p>
                </div>
            </div>
        </div>
        
    }
}




// WEBPACK FOOTER //
// ./frontEnd/nominas/nominaIG/components/EnrocarOperadores.jsx